import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '@/constants/queryKey';
import { getPaymentPrice } from '@/apis/payment';
import type { GetPaymentPriceRequestProps } from '@/types/payment.types';

const usePaymentPrice = ({
  userId = 0,
  newWorkerCount = 0,
  workerCount,
  enabled = true,
  suppressError = false, // Suppress error toast nếu không cần thiết
}: GetPaymentPriceRequestProps & { enabled?: boolean; suppressError?: boolean }) => {
  const { data, isLoading, isError } = useQuery(
    [QUERY_KEY.PAYMENT_PRICE, userId, newWorkerCount, workerCount],
    {
      queryFn: () =>
        getPaymentPrice({
          userId,
          newWorkerCount,
          workerCount,
        }),
      enabled: enabled && newWorkerCount > 0 && userId > 0, // Chỉ gọi nếu có workers cần thanh toán và user là paid user
      retry: false, // Không retry để tránh spam error
      // Suppress error trong global error handler nếu suppressError = true
      meta: {
        suppressErrorToast: suppressError,
      },
    }
  );

  if (isLoading || isError) {
    return 0;
  }

  return data?.data?.price || 0;
};

export default usePaymentPrice;
